import React from 'react'
import {Link} from "react-router-dom"

export default function Products() {
  return (
    <div>
      
      <body background={require('./images/a2.jpg')} >      
   
    <table align="center" width="900">
          
    <tr>

      <td width="200" align="center"> <Link to="/Home"> <h3><font face="Trebuchet" color="white" size="4">Home</font></h3></Link></td>
      <td width="200" align="center"> <Link to="/Products"><h3><font face="Trebuchet" color="white" size="4">Products</font></h3></Link></td>
     
      <td width="200" align="center"> <Link to="/Clients"><h3><font face="Trebuchet" color="white" size="4">Clients</font></h3></Link></td> 
      
      <td width="200" align="center"> <Link to="/Contact"><h3><font face="Trebuchet" color="white" size="4">Contact us</font></h3></Link></td>  

    </tr>

    </table>

  

    <table align="center" cellspacing="5"  cellpadding="5">

<tr>


<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/sunset.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/sunrise.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/surathalee.jpg')}/> </td>

</tr>

<tr>



<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/beragala.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/diyaluma.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/peacock.jpg')}/> </td>

</tr>


<tr>


<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/fishing.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/fowl.jpg')}/> </td>

<td  width="350"  height="200"> <img alt="Product-1" width="350"  height="200" src={require('./images/beach.jpg')}/> </td>

</tr>


</table>

<h4 align="center"> <font size="3" color="white" face="Times New Roman">Developed & Updated on 2024-02-11 by Priyantha Wanninayake  Email : kstpromotions@gmail.com  </font></h4>


</body>

    </div>
  )
}